import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/variables.css';
import './styles/globals.css';
import { installFeedbackCapture } from './services/feedbackCapture';

// In-memory only: lets a feedback report say what the session was doing (#120).
installFeedbackCapture();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
